import React from 'react'
import { Box, Typography } from '@mui/material'

import Image from '../Image'

type CompleteToolsetProps = {
  data: {
    title: string
    subTitle: string
    content: {
      tag: string
      icon: {
        asset: {
          url: string
        }
      }
      content: string
    }[]
    showDivider: boolean
  }
}

export const CompleteToolset = ({ data }: CompleteToolsetProps) => (
  <Box
    sx={{
      pt: { xs: 7, mobile: 11, laptop: 12 }
    }}>
    <Box
      sx={{
        maxWidth: 1152,
        mx: 'auto',
        pb: { xs: 6, mobile: 11, laptop: 12 },
        px: {
          xs: 3,
          mobile: 8,
          laptop: 4,
          desktop: 0
        }
      }}>
      <Typography
        variant='h1'
        component='h2'
        sx={{
          fontSize: { laptop: 48 },
          letterSpacing: '-0.04em',
          textAlign: 'center'
        }}>
        {data.title}
      </Typography>

      <Typography
        variant='h3'
        sx={{
          color: 'text.secondary',
          letterSpacing: '-0.04em',
          mt: { xs: 1, mobile: 1.5, laptop: 3 },
          textAlign: 'center'
        }}>
        {data.subTitle}
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gap: { xs: 3, mobile: 2.5, laptop: 3 },
          gridTemplateColumns: {
            mobile: 'repeat(2, 1fr)',
            laptop: 'repeat(4, 1fr)'
          },
          mt: { xs: 7, laptop: 9 }
        }}>
        {data.content.map(item => (
          <Box
            key={item.tag}
            sx={{
              border: 1,
              borderColor: 'border.main',
              borderRadius: 2,
              minHeight: { xs: 276, mobile: 368 },
              p: 3
            }}>
            <Typography
              sx={{
                width: 'fit-content',
                bgcolor: 'border.main',
                borderRadius: 0.5,
                fontWeight: 'medium',
                lineHeight: 1,
                p: 1
              }}>
              {item.tag}
            </Typography>
            <Box sx={{ mt: { xs: 3, mobile: 4.5 } }}>
              <Image url={item.icon.asset?.url} width='100' />
            </Box>
            <Typography
              sx={{
                fontSize: { xs: 20, mobile: 24 },
                fontWeight: 'medium',
                letterSpacing: '-0.04em',
                lineHeight: 1.2,
                mt: { xs: 3, mobile: 4.5 }
              }}>
              {item.content}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>

    {data.showDivider && <Box className='section-divider' />}
  </Box>
)
